import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, useTheme, useMediaQuery, Box, Breadcrumbs, Link, Typography, IconButton } from "@material-ui/core";
import { ControlFields } from "./property-controls/ControlFields";
import { Formik, Form, useFormikContext, Field } from "formik";
import { isGridComponent } from "./content/types";
// import { useDebounce } from "use-debounce";
import * as ContentComponentsWithControls from "./content/with-property-controls";
import { ControlType, isControlComponent } from "./property-controls";
import { isNotNull } from "@ploy-lib/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { makeStyles } from "@material-ui/core/styles";
import { FormikSubmitButton } from "./property-controls/fields/FormikSubmitButton";
import { GridItemWrapper } from "./GridItemWrapper";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { defineMessage } from "@formatjs/intl";
const useStyles = makeStyles(theme => ({
    dialogPaper: {
        overflow: "hidden"
    },
    dialogContent: {
        [theme.breakpoints.up("md")]: {
            overflow: "hidden"
        }
    }
}));
export function GridItemEditor(props) {
    const classes = useStyles(props);
    const { component, initialValues, onSubmit, open, onClose } = props;
    const intl = useIntl();
    const Component = ContentComponentsWithControls[component];
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const [selected, setSelected] = useState();
    if (!isControlComponent(Component))
        return null;
    let controls = Component.propertyControls;
    let arrayControl = null;
    const selectedControls = selected
        ?.split(".")
        .map((p, i, arr) => {
        let title = arrayControl ? `[${p}]` : undefined;
        const control = arrayControl ?? controls?.[p];
        controls = null;
        arrayControl = null;
        const fieldName = arr.slice(0, i + 1).join(".");
        if (control?.type === ControlType.Object) {
            controls = control.propertyControls;
            title = title ?? control.title;
        }
        else if (control?.type === ControlType.Array &&
            control.propertyControl.type !== ControlType.Enum) {
            arrayControl = control.propertyControl;
            title = title ?? control.title;
        }
        if (!control)
            return null;
        return { title, fieldName };
    })
        .filter(isNotNull);
    return (_jsx(Dialog, { open: open, onClose: onClose, "aria-labelledby": "form-dialog-title", maxWidth: "md", fullWidth: true, fullScreen: fullScreen, classes: {
            paper: classes.dialogPaper
        }, children: _jsx(Formik, { initialValues: initialValues, onSubmit: onSubmit, validateOnBlur: false, validateOnChange: false, validateOnMount: false, children: _jsxs(_Fragment, { children: [_jsx(Box, { clone: true, display: "flex", alignItems: "center", children: _jsxs(DialogTitle, { disableTypography: true, children: [_jsx(IconButton, { onClick: () => setSelected(selectedControls?.[selectedControls.length - 2]?.fieldName), disabled: !selectedControls, title: intl.formatMessage(defineMessage({
                                        id: "dploy.grid.item-edit.breadcrumbs.back-button.label",
                                        defaultMessage: "Back"
                                    })), children: _jsx(ChevronLeftIcon, {}) }), _jsxs(Breadcrumbs, { children: [!selected ? (_jsx(Typography, { variant: "h6", id: "form-dialog-title", children: _jsx(Field, { name: "boxProps.header", children: (props) => props.field.value ??
                                                    intl.formatMessage(componentNamesMessages[component]) }) })) : (_jsx(Link, { id: "form-dialog-title", component: "button", type: "button", variant: "h6", color: "inherit", onClick: () => setSelected(undefined), disabled: !selected, underline: "hover", children: _jsx(Field, { name: "boxProps.header", children: (props) => props.field.value ??
                                                    intl.formatMessage(componentNamesMessages[component]) }) })), selectedControls?.map(({ title, fieldName }) => selected === fieldName ? (_jsx(Typography, { variant: "h6", children: title }, fieldName)) : (_jsx(Link, { component: "button", type: "button", variant: "h6", color: "inherit", onClick: () => setSelected(fieldName), underline: "hover", children: title }, fieldName)))] })] }) }), _jsx(DialogContent, { className: classes.dialogContent, children: _jsx(Form, { children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Box, { clone: true, overflow: [undefined, undefined, "auto"], maxHeight: [undefined, undefined, "calc(100vh - 200px)"], children: _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(ControlFields, { propertyControls: Component.propertyControls, margin: "dense", onSelect: setSelected, selected: selected }) }) }), _jsx(Box, { clone: true, overflow: "auto", maxHeight: [undefined, undefined, "calc(100vh - 200px)"], children: _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(Preview, { component: component, minHeight: isGridComponent(Component)
                                                    ? Component.minHeight
                                                    : undefined }) }) })] }) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: () => {
                                    setSelected(undefined);
                                    onClose?.();
                                }, children: _jsx(FormattedMessage, { id: "dploy.grid.item-edit.cancel-button.label", defaultMessage: "Cancel" }) }), _jsx(FormikSubmitButton, { variant: "outlined", color: "primary", children: _jsx(FormattedMessage, { id: "dploy.grid.item-edit.save-button.label", defaultMessage: "Save" }) })] })] }) }) }));
}
function Preview(props) {
    const { component, minHeight = 250 } = props;
    const form = useFormikContext();
    // const [previewProps] = useDebounce(form.values, 1000);
    const previewProps = form.values;
    return (_jsx(Box, { minHeight: minHeight, clone: true, children: _jsx(GridItemWrapper, { id: "editing-item", component: component, properties: previewProps }) }));
}
const componentNamesMessages = defineMessages({
    Charts: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.Charts",
        defaultMessage: "Charts",
        description: "Charts component container for dashboard"
    },
    Competitions: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.Competitions",
        defaultMessage: "Competitions",
        description: "Competitions component container for dashboard"
    },
    GeneralInformation: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.GeneralInformation",
        defaultMessage: "GeneralInformation",
        description: "GeneralInformation component container for dashboard"
    },
    Links: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.Links",
        defaultMessage: "Links",
        description: "Links component container for dashboard"
    },
    News: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.News",
        defaultMessage: "News",
        description: "News component container for dashboard"
    },
    RecentApplications: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.RecentApplications",
        defaultMessage: "RecentApplications",
        description: "RecentApplications component container for dashboard"
    },
    Text: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.Text",
        defaultMessage: "Text",
        description: "Text component container for dashboard"
    },
    TextList: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.TextList",
        defaultMessage: "TextList",
        description: "TextList component container for dashboard"
    },
    Todos: {
        id: "dploy.grid.item-edit.breadcrumbs.form-dialog-title.Todos",
        defaultMessage: "Todos",
        description: "Todos component container for dashboard"
    }
});
//# sourceMappingURL=GridItemEditor.js.map